<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/subscription-account']" translate>SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT</a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/import-export-home']">{{ this.mng_impexp_title }}</a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>IMPORT_EXPORT_SECTION.EXP_HISTORY</span>
</div>

<tb-header specificTitle="IMPORT_EXPORT_SECTION.EXP_HISTORY" [specificSubTitle]="this.subDescriSelected +' ('+ this.subKeySelected +')'"></tb-header>

<div class="contentGlobal">
    <div style="display: flex; justify-content: center; flex-wrap: wrap">
        <div>
            <mat-card class="fuse-card-grid">
                <mat-card-header>
                    <mat-card-title translate>IMPORT_EXPORT_SECTION.DOWNLOAD_TABLE_TITLE</mat-card-title>
                </mat-card-header>

                <div class="contentGlobal">
                    <div style="display: flex; justify-content: space-between">
                        <div style="flex-grow: 2" class="inputSearchStyle">
                            <mat-form-field appearance="outline">
                                <mat-label translate>COMMONS.SEARCH</mat-label>
                                <mat-icon matPrefix [inline]="true">search</mat-icon>
                                <input matInput (keyup)="applyFilterSubscriptions($event)" placeholder="{{ 'COMMONS.SEARCH' | translate }}"  [(ngModel)]="searchText" />
                                <mat-icon matSuffix [inline]="true" (click)="clearSubscriptionSearch()" class="pointer">highlight_off</mat-icon>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="message-box info">
                        {{ 'IMPORT_EXPORT_SECTION.NO_EXP_DOWNL_DESCR_1' | translate }} <button mat-icon-button color="primary" (click)="getDownloadFilesList()">
                        <mat-icon>refresh</mat-icon>
                        </button>
                    </div>

                    <div class="table-body" *ngIf="downloadFound; else elseNoFile">
                        <table mat-table #filesTable [dataSource]="filesT" matSort>
                            <ng-container matColumnDef="FileName">
                                <mat-header-cell *matHeaderCellDef>
                                    <mat-label translate>COMMONS.FILE_NAME</mat-label>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{ element.fileName }} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="CreationDate">
                                <mat-header-cell *matHeaderCellDef translate>EDIT_SUBSCRIPTION.CREATION_DATE</mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <input matInput [matDatepicker]="eD" [ngModel]="element.dateCreat" name="CreationDate" />
                                    <mat-datepicker #eD [disabled]="saving2"></mat-datepicker>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="Download">
                                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="justify-content: flex-end">
                                    <button mat-icon-button (click)="downloadThis(element)">
                                        <mat-icon>cloud_download</mat-icon>
                                    </button>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumnsFiles"></mat-header-row>
                            <mat-row class="pointer" *matRowDef="let row; columns: displayedColumnsFiles"></mat-row>
                        </table>
                        <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="5" #filesPaginator showFirstLastButtons> </mat-paginator>
                    </div>
                    <ng-template #elseNoFile>
                        <mat-label translate>IMPORT_EXPORT_SECTION.NO_DOWNLOAD_FILES_AVAILABLE</mat-label>
                    </ng-template>
                </div>
            </mat-card>

            <div *ngIf="loading">
                <tb-loading></tb-loading>
            </div>
        </div>
    </div>
</div>
